import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import api from '../../../app/api/api';
import { AxiosError } from 'axios';
import { RootState } from '../../../app/store/configureStore';
import { RestaurantTable } from '../../manager/tables/types';

export const fetchWaiterTableListAsync = createAsyncThunk(
  'restaurantWaiter/fetchTables',
  async ({ restaurantId }: { restaurantId: string }, thunkAPI) => {
    try {
      return await api.RestaurantWaiter.tables(restaurantId);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        return thunkAPI.rejectWithValue({ error: error.response?.data });
      }
      return thunkAPI.rejectWithValue({ error: 'An unknown error occurred' });
    }
  }
);

const waiterTablesAdapter = createEntityAdapter<RestaurantTable>();

export const waiterTableSlice = createSlice({
  name: 'waiterTable',
  initialState: waiterTablesAdapter.getInitialState({
    tablesLoaded: false,
    status: 'idle',
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWaiterTableListAsync.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchWaiterTableListAsync.fulfilled, (state, action) => {
        if (Array.isArray(action.payload)) {
          waiterTablesAdapter.setAll(state, action.payload);
          state.tablesLoaded = true;
        } else {
          console.error('Expected an array but got:', action.payload);
        }
        state.status = 'idle';
      })
      .addCase(fetchWaiterTableListAsync.rejected, (state) => {
        state.status = 'idle';
      });
  },
});

export const waiterTableSelectors = waiterTablesAdapter.getSelectors(
  (state: RootState) => state.waiterTables
);
